export enum DATE_RANGE {
  'ONE' = '1',
  'SEVEN' = '7',
  'THIRTY' = '30',
  'NINETY' = '90',
  'CUSTOM' = 'custom',
  'CLEAR' = ''
}